export const initialState = {
  pathname: '',
  gender: 'female',
  values: {},

  meta: {
    title: '',
    description: '',
    name: '',
    category: '',
  },
  title: '',
  description: '',

  note: {},

  productReviews: [],
  products: [],
  brands: [],
  notes: [],
  tags: {
    female: [],
    male: [],
  },
}
